<template>
  <div :class="$style.main">
    <div :class="$style.selectBox">
      <div
        :class="$style.select"
        v-if="$store.getters.language === 'cn'"
        @click="handleLanguage('pr')">繁</div>
      <div
        :class="$style.select"
        v-if="$store.getters.language === 'us'"
        @click="handleLanguage('cn')">En</div>
      <div
        :class="$style.select"
        v-if="$store.getters.language === 'pr'"
        @click="handleLanguage('us')">Pt</div>
    </div>
    <c-header type="mobile"/>
    <router-view @loading="handeLoading"/>
    <c-footer type="mobile" @open="handleOpen"/>
    <van-popup v-model="showAboutme">
      <common-dialog @close="handelClose" :title="$t('common.aboutus')">
        <c-info type="2"/>
      </common-dialog>
    </van-popup>
    <van-popup v-model="showCallme">
      <common-dialog @close="handelClose" :title="$t('common.Contactus')">
        <c-info type="3"/>
      </common-dialog>
    </van-popup>
    <van-popup v-model="showOther">
      <common-dialog @close="handelClose" :title="$t('common.Useandprivacypolicy')">
        <c-info type="4"/>
      </common-dialog>
    </van-popup>
    <div :class="$style.loading" v-if="loading">
      <van-loading size="24px" text-color="#0094ff" color="#0094ff">{{ $t("common.submitL") }}...</van-loading>
    </div>
  </div>
</template>

<script>
  import { Popup, Loading} from "vant";
  import Footer from "../../components/footer";
  import Info from "../../components/info";
  import Header from "../../components/header";
  import { commonDialog } from "./components";
  export default {
    name: "Mobile",
    components: {
      "van-popup": Popup,
      "c-header": Header,
      "c-footer": Footer,
      "c-info": Info,
      "van-loading": Loading,
      commonDialog
    },
    data () {
      return {
        loading: false,
        title: "mobile",
        showAboutme: false,
        showCallme: false,
        showOther: false
      };
    },
    methods: {
      handeLoading (data) {
        this.loading = data;
      },
      handleOpen (type) {
        switch (type) {
        case "aboutMe" : {
          this.showAboutme = true;
          break;
        }
        case "callMe" : {
          this.showCallme = true;
          break;
        }
        case "other" : {
          this.showOther = true;
          break;
        }
        }
      },
      handelClose () {
        this.showAboutme = false;
        this.showCallme = false;
        this.showOther = false;
      },
      handleLanguage (type) {
        const el = document.querySelector(".footer-box");
        const emorel = document.querySelector(".footer-more");

        if (type === "pr") {
          el.style.height = "310px";
          emorel.style.bottom = "80px";
        }
        if (type === "cn") {
          el.style.height = "280px";
          emorel.style.bottom = "80px";
        }
        console.log(type);
        this.$i18n.locale = type;
        this.$store.commit("changeLanguage", type);
      }
    },
    mounted () {
      if (localStorage.getItem("pageData") && JSON.parse(localStorage.getItem("pageData")).length !== 0) {
        this.$router.push({path: "/eDCBNI/mobile/List"});
      } else {
        this.$router.push({path: "/eDCBNI/mobile/Declaration"});
      }
    }
  };
</script>

<style lang="scss" module src="./style.scss">
</style>

<style lang="scss">
.van-button--primary {
  background-color: #43a6df;
}
</style>